import { GenericService } from './generic.service';
import { Condition } from '@/models';

export class ConditionService extends GenericService<Condition> {
  endpoint = 'v1/conditions';
}
